import { UPDATE_FIRST_RUN, REFRESH_THEMES_SECTION } from "./keys";

const initialState = {
  firstRun: true,
  refreshThemes: false,
  productRoute:'socialwalls',
}

export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case UPDATE_FIRST_RUN: {
      return { ...state, firstRun: payload }
    }
    case REFRESH_THEMES_SECTION: {
      return {
        ...state, refreshThemes: !state.refreshThemes
      }
    }
    default:
      return { ...state }
  }
}